import { ErrorPage } from '@app/components/error-page';
import { ShieldAlert } from 'lucide-react';
import { useTranslation } from 'react-i18next';

function Forbidden() {
    const { t } = useTranslation();

    return (
        <ErrorPage
            statusCode={403}
            title={t('pages.errors.403.title')}
            description={t('pages.errors.403.description')}
            icon={<ShieldAlert className="text-destructive h-10 w-10" />}
        />
    );
}

// noinspection JSUnusedGlobalSymbols
export default Forbidden;
